import GatewayBase from './gateway-base';

export interface IntegrationFieldDefinition {
  [key: string]: {
    type: string;
    display: string;
    attributes: Record<string, any>;
  };
}

export default class GorgiasService extends GatewayBase {
  get integrations() {
    return {
      installed: this.getInstalledIntegrations,
      list: this.listIntegrations,
      setEnabled: this.setIntegrationEnabled,
    };
  }

  private listIntegrations = () => {
    return this.client.get<{
      schemas: { id: string; name: string; icon: string; fields: IntegrationFieldDefinition }[];
    }>('/v1/gorgias/integrations');
  };

  private getInstalledIntegrations = (storeId: string) => {
    return this.client.get<{ integrationId: string; storeId: string; enabled: boolean; configuration: any }[]>(
      `/v1/gorgias/integrations/installed/${storeId}`,
    );
  };

  private setIntegrationEnabled = (id: string, storeId: string, enabled: boolean) => {
    return this.client.patch(`/v1/gorgias/integrations/${id}/${storeId}/enabled`, { enabled });
  };
}
